module.exports = __webpack_public_path__ + "img/leshrac.f686c9e6.png";